import { ROUTES } from "./routes";

const DAYS_OPTIONS = [
  { label: "شنبه", value: "Saturday", isDisabled: false },
  { label: "یکشنبه", value: "Sunday", isDisabled: false },
  { label: "دوشنبه", value: "Monday", isDisabled: false },
  { label: "سه‌شنبه", value: "Tuesday", isDisabled: false },
  { label: "چهارشنبه", value: "Wednesday", isDisabled: false },
  { label: "پنجشنبه", value: "Thursday", isDisabled: false },
  { label: "جمعه", value: "Friday", isDisabled: false },
];

const DURATIONS_OPTIONS = [
  { label: "30 دقیقه", value: "00:30:00" },
  { label: "45 دقیقه", value: "00:45:00" },
  { label: "1 ساعت", value: "01:00:00" },
  { label: "1 ساعت و 15 دقیقه", value: "01:15:00" },
  { label: "1 ساعت و 30 دقیقه", value: "01:30:00" },
  { label: "1 ساعت و 45 دقیقه", value: "01:45:00" },
  { label: "2 ساعت", value: "02:00:00" },
];


const BELL_OPTIONS = (num) => {
  let ones = ['', 'یک', 'دو', 'سو', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه',
    'ده', 'یازده', 'دوازده', 'سیزده', 'چهارده', 'پانزده', 'شانزده',
    'هفده', 'هجده', 'نوزده'];
  let tens = ['', '', 'بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'هشتاد',
    'نود'];

  let numString = num.toString();
  //the case of 1 - 20
  let str;
  if (num < 20) {
    num === 1 ? str = { label: `زنگ اول`, value: num } :
      str = { label: ` زنگ ${ones[num]}م`, value: num };
    return str;
  }

  if (numString.length === 2) {
    num === 30 ? str = { label: `زنگ ${tens[numString[0]] + ' ' + ones[numString[1]]}ام`, value: num } :
      num % 10 === 0 ? str = { label: `زنگ ${tens[numString[0]] + '' + ones[numString[1]]}م`, value: num } :
        str = { label: `زنگ ${tens[numString[0]] + ' و ' + ones[numString[1]]}م`, value: num };
    return str;
  }

  //100 and more
  if (numString.length === 3) {
    if (numString[1] === '0' && numString[2] === '0')
      return ones[numString[0]] + ' hundred';
    else
      return ones[numString[0]] + ' hundred and ' + BELL_OPTIONS(+(numString[1] + numString[2]));
  }

  if (numString.length === 4) {
    var end = +(numString[1] + numString[2] + numString[3]);
    if (end === 0) return ones[numString[0]] + ' thousand';
    if (end < 100) return ones[numString[0]] + ' thousand and ' + BELL_OPTIONS(end);
    return ones[numString[0]] + ' thousand ' + BELL_OPTIONS(end);
  }
};


const PERSIAN_DAYS = {
  Sunday: 'یکشنبه',
  Monday: 'دوشنبه',
  Tuesday: 'سه‌شنبه',
  Wednesday: 'چهارشنبه',
  Thursday: 'پنجشنبه',
  Friday: 'جمعه',
  Saturday: 'شنبه',
};

const SOURCE_TYPES = {
  Study : 'Study',
  Free : 'Free',
  Review :'Review'
}
const ENROLLMENT_DETAIL = {
  Ordinary : 'Ordinary',
  Fixed : 'Fixed'
}

const DEGREES_LIST = [
  { label: 'دیپلم', value: 'دیپلم' },
  { label: 'فوق دیپلم', value: 'فوق دیپلم' },
  { label: 'کارشناسی', value: 'کارشناسی' },
  { label: 'کارشناسی ارشد', value: 'کارشناسی ارشد' },
  { label: 'دکترا', value: 'دکترا' },
]


const ALL_GENERATED_TIMETABLE_ROUTES = [
  ROUTES.MICROSCOPIC_PLAN.PATH,
  ROUTES.TIMING_PLAN.PATH,
  ROUTES.TELESCOPIC_PLAN.PATH,
]
const MIME_TYPE = {
  'image/x-ms-bmp': 'bmp',
  'image/gif': 'gif',
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'application/x-7z-compressed': '7z',
  'application/pdf': 'pdf',
  'application/zip': 'zip',
  'application/x-rar-compressed': 'rar',
  'application/octet-stream': 'rar'
}
const VERSION = "version";

export {
  DAYS_OPTIONS,
  DURATIONS_OPTIONS,
  BELL_OPTIONS,
  PERSIAN_DAYS,
  SOURCE_TYPES,
  ENROLLMENT_DETAIL,
  DEGREES_LIST,
  ALL_GENERATED_TIMETABLE_ROUTES,
  MIME_TYPE,
  VERSION
};
